import { render, staticRenderFns } from "./agrega_usuario.vue?vue&type=template&id=67c2254d&scoped=true"
import script from "./agrega_usuario.vue?vue&type=script&lang=js"
export * from "./agrega_usuario.vue?vue&type=script&lang=js"
import style0 from "./agrega_usuario.vue?vue&type=style&index=0&id=67c2254d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c2254d",
  null
  
)

export default component.exports